<template>
  <div class="padding-xl">
    <div class="shadow-warp">
      <div class="padding solid-bottom text-red text-lg"><i class="cuIcon-titles"></i> 基本信息</div>
      <div class="padding">
        <div class="flex justify-between align-center">
          <div class="flex justify-start align-center">
            <div>手机号码：</div>
            <div v-if="modifyPhoneState" class="flex justify-start align-center">
              <div>
                <el-input placeholder="请输入新的手机号码" v-model="loginObject.phone" maxlength="11"></el-input>
              </div>
              <div class="padding-lr text-blue">
                <div class="text-right" :class="countdown === 60?'text-blue':'text-gray'"
                     @click="sendCaptcha" :style="canSend()?'cursor: pointer':'cursor: not-allowed'">
                  <span>{{ codeText }}</span>
                </div>
              </div>
              <div class="padding-left">验证码：</div>
              <div>
                <el-input maxlength="6" placeholder="6位验证码" style="margin-right: 0;width: 100px;"
                          v-model="loginObject.captcha"/>
              </div>
            </div>
            <div v-else>{{ user.phone ? user.phone : '' }}</div>
          </div>
          <div>
            <button class="cu-btn bg-red radius" @click="modifyPhone"
                    :style="canPost()?'cursor: pointer':'cursor: not-allowed'">{{ modifyPhoneState ? '保存' : '修改' }}
            </button>
            <button v-if="modifyPhoneState" class="margin-left cu-btn radius" @click="cancelPhone">取消</button>
          </div>
        </div>
        <div class="padding-top flex justify-between align-center">
          <div class="flex justify-start align-center">
            <div>所属区域：</div>
            <v-region :type="areaType" v-model="selected"></v-region>
          </div>
          <div>
            <button class="cu-btn bg-red radius" @click="modifyArea">{{ areaType === 'select' ? '保存' : '修改' }}</button>
            <button v-if="areaType==='select'" class="margin-left cu-btn radius" @click="cancelArea">取消</button>
          </div>
        </div>
      </div>
    </div>
    <div class="padding"></div>
    <div class="shadow-warp">
      <div class="padding solid-bottom flex justify-between align-center">
        <div class="text-red text-lg"><i class="cuIcon-titles"></i> 默认收件地址</div>
        <div>
          <button class="cu-btn bg-red radius" @click="saveAddress">{{ changeAddress ? '保存' : '修改' }}</button>
          <button v-if="changeAddress" class="margin-left cu-btn radius" @click="changeAddress = false">取消</button>
        </div>
      </div>
      <div class="padding">
        <div class="flex align-center padding-top">
          <div class="flex align-center">
            <div class="info-label">收件单位：</div>
            <div v-if="changeAddress">
              <el-input v-model="address.addressOrg" style="min-width: 400px;" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.addressOrg }}</div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">收件人：</div>
            <div v-if="changeAddress">
              <el-input v-model="address.addressPerson" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.addressPerson }}</div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">邮编：</div>
            <div v-if="changeAddress">
              <el-input v-model="address.addressZip" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.addressZip }}</div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">手机号：</div>
            <div v-if="changeAddress">
              <el-input v-model="address.addressPhone" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.addressPhone }}</div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">座机：</div>
            <div v-if="changeAddress">
              <el-input v-model="address.addressTelephone" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.addressTelephone }}</div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="info-label">收货地址：</div>
          <div v-if="changeAddress">
            <v-region v-model="addressSelected"></v-region>
          </div>
          <div v-else class="view-label">
            <v-region type="text" v-model="addressSelected" class="bg-white"></v-region>
          </div>
        </div>
        <div class="flex align-center padding-tb">
          <div class="flex justify-start align-center">
            <div class="info-label">街道：</div>
            <div v-if="changeAddress">
              <el-input v-model="address.addressStreet" style="min-width: 400px;" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.addressStreet }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding"></div>
    <div class="shadow-warp">
      <div class="padding solid-bottom flex justify-between align-center">
        <div class="text-red text-lg"><i class="cuIcon-titles"></i> 默认发票信息</div>
        <div>
          <button class="cu-btn bg-red radius" @click="saveInvoice">{{ changeInvoice ? '保存' : '修改' }}</button>
          <button v-if="changeInvoice" class="margin-left cu-btn radius" @click="changeInvoice = false">取消</button>
        </div>
      </div>
      <div class="padding">
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">单位名称：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoiceOrg" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoiceOrg }}</div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">税号：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoiceTaxNum" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoiceTaxNum }}</div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">接收手机：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoiceReceivePhone" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoiceReceivePhone }}</div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">接收邮箱：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoiceMail" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoiceMail }}</div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">开户行：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoiceBank" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoiceBank }}</div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">帐号：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoiceBankAccount" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoiceBankAccount }}</div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">电话：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoicePhone" size="small"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoicePhone }}</div>
          </div>
        </div>
        <div class="flex align-center padding-tb">
          <div class="flex justify-start align-center">
            <div class="info-label">地址：</div>
            <div v-if="changeInvoice">
              <el-input v-model="invoice.invoiceOrgAddress" size="small" style="min-width: 400px;"></el-input>
            </div>
            <div v-else class="view-label">{{ user.invoiceOrgAddress }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding-xl"></div>
  </div>
</template>

<script>
import bs from '@/services/data/bs'

export default {
  name: 'personal',
  data () {
    return {
      modifyPhoneState: false,
      phone: '',
      countdown: 60,
      codeText: '获取验证码',
      loginObject: {
        phone: '',
        captcha: ''
      },
      areaType: 'text',
      selected: {
        province: '',
        city: '',
        area: '',
        town: ''
      },
      addressSelected: {
        province: '',
        city: '',
        area: '',
        town: ''
      },
      user: {},
      address: {
        addressOrg: '',
        addressPhone: '',
        addressArea: '',
        addressStreet: '',
        addressZip: '',
        addressPerson: ''
      },
      invoice: {
        invoiceOrg: '',
        invoiceTaxNum: '',
        invoiceBankAccount: '',
        invoiceBank: '',
        invoiceOrgAddress: '',
        invoicePhone: '',
        invoiceMail: '',
        invoiceReceivePhone: ''
      },
      changeAddress: false,
      changeInvoice: false
    }
  },
  created () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
  },
  watch: {
    user (val, oldVal) {
      if (val) {
        if (val.area) {
          const areas = val.area.split(',', -1)
          this.selected.province = areas[0]
          this.selected.city = areas[1]
          this.selected.area = areas[2]
        }
        this.address.addressOrg = this.user.addressOrg
        this.address.addressPhone = this.user.addressPhone
        this.address.addressStreet = this.user.addressStreet
        this.address.addressZip = this.user.addressZip
        this.address.addressPerson = this.user.addressPerson
        if (val.addressArea) {
          const areas = val.addressArea.split(',', -1)
          this.addressSelected.province = areas[0]
          this.addressSelected.city = areas[1]
          this.addressSelected.area = areas[2]
        }
        this.invoice.invoiceOrg = this.user.invoiceOrg
        this.invoice.invoiceTaxNum = this.user.invoiceTaxNum
        this.invoice.invoiceBankAccount = this.user.invoiceBankAccount
        this.invoice.invoiceBank = this.user.invoiceBank
        this.invoice.invoiceOrgAddress = this.user.invoiceOrgAddress
        this.invoice.invoicePhone = this.user.invoicePhone
        this.invoice.invoiceMail = this.user.invoiceMail
        this.invoice.invoiceReceivePhone = this.user.invoiceReceivePhone
      }
    }
  },
  methods: {
    saveAddress () {
      if (this.changeAddress) {
        this.address.addressArea = this.addressSelected.province + ',' + this.addressSelected.city + ',' + this.addressSelected.area
        bs.user.changeAddress(this.address, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '默认收件地址修改成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.user = res.data
            this.changeAddress = false
          } else {
            this.$message.error('默认收件地址修改失败')
          }
        })
      } else {
        this.changeAddress = true
      }
    },
    saveInvoice () {
      if (this.changeInvoice) {
        bs.user.changeInvoice(this.invoice, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '默认发票信息修改成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.user = res.data
            this.changeInvoice = false
          } else {
            this.$message.error('默认发票信息修改失败')
          }
        })
      } else {
        this.changeInvoice = true
      }
    },
    cancelArea () {
      this.areaType = 'text'
    },
    modifyArea () {
      if (this.areaType === 'text') {
        this.areaType = 'select'
      } else {
        if (this.selected.area !== '' && this.selected.area !== 'null') {
          bs.user.changeArea(this.selected.province + ',' + this.selected.city + ',' + this.selected.area, (res) => {
            if (res.code === 200) {
              this.$message({
                message: '行政区划修改成功',
                type: 'success'
              })
              sessionStorage.setItem('user', JSON.stringify(res.data))
              this.user = res.data
            } else {
              this.$message.error('行政区划修改失败')
            }
          })
        } else {
          this.$message.error('请选择到区县')
          return false
        }
        this.areaType = 'text'
      }
    },
    cancelPhone () {
      this.modifyPhoneState = false
    },
    modifyPhone () {
      if (this.modifyPhoneState) {
        this.changePhone()
        this.modifyPhoneState = false
      } else {
        this.modifyPhoneState = true
      }
    },
    canPost () {
      return this.modifyPhoneState === false || (this.loginObject.phone.length === 11 && this.loginObject.captcha.length === 6)
    },
    canSend () {
      return this.loginObject.phone.length === 11 && this.countdown === 60
    },
    sendCaptcha () {
      if (this.canSend()) {
        bs.user.code(this.user.phone, this.loginObject.phone, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '验证码发送成功',
              type: 'success'
            })
            this.countdown = 59
            this.setCountDown()
          } else if (res.code === 301) {
            this.$message.error('手机号码不正确')
          } else {
            this.$message.error('验证码发送失败')
          }
        })
      }
    },
    changePhone () {
      if (this.canPost()) {
        bs.user.changePhone(this.loginObject.phone, this.loginObject.captcha, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '电话号码修改成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.user = res.data
            if (this.user.phone) {
              this.$emit('phoneChanged', this.user.phone)
            }
          } else {
            this.$message.error('电话号码修改失败')
          }
        })
      }
    },
    setCountDown: function () {
      setTimeout(() => {
        this.codeText = this.countdown + '秒后重试'
        this.countdown--
        if (this.countdown === 0) {
          this.codeText = '获取验证码'
          this.countdown = 60
        } else {
          this.setCountDown()
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.info-label {
  width: 80px;
  padding: 2px 0;
  text-align: right;
}

.view-label {
  min-width: 200px;
}

</style>
